<script setup>
import { XMarkIcon } from '@heroicons/vue/24/outline'
import { storeToRefs } from 'pinia'
import { useAlertStore } from '@store'

const alertStore = useAlertStore()
const { alerts } = storeToRefs(alertStore)

const generateToastColor = (notificationClass) => {
  switch (notificationClass) {
    case 'success':
      return 'border-green-500'
    case 'error':
      return 'border-red-500'
    default:
      return 'border-gray-500'
  }
}
</script>

<template>
  <Teleport to="body">
    <div class="toast toast-end global-toast-layer">
      <div
        class="alert flex flex-col rounded-md shadow-md bg-white opacity-1 border-0 border-l-2 border-b-2 p-0 gap-0"
        :class="generateToastColor(alert.notification_class)"
        v-for="(alert, index) in alerts"
        :key="index"
      >
        <div class="flex justify-between w-full p-2">
          <span class="text-base font-bold">{{ alert.title }}</span>
          <button class="" @click="alertStore.removeAlert(alert.id)">
            <XMarkIcon class="h-4 w-4" />
          </button>
        </div>
        <div class="text-base p-2 pb-3 text-left w-full">
          {{ alert.message }}
        </div>
      </div>
    </div>
  </Teleport>
</template>

<style scoped>
.global-toast-layer {
  position: fixed !important;
  top: auto !important;
  right: 1rem !important;
  left: auto !important;
  bottom: 1rem !important;

  /* Keep the toast above every modal and overlay */
  z-index: 2147483647 !important;

  /* Do not block the page outside the toast */
  pointer-events: none;
}

.alert {
  min-width: 20rem !important;
  pointer-events: auto;
}
</style>
